import { Tag, Tags } from '../interfaces';

const getData = (id: string, value: Tags[0], questions?: Tag[]) => {
  const questionId = id.split(':')[1];
  const question = questions?.find((q) => q.id.toString() === questionId);
  const valueId = value.toString().split(':')[1];
  const answer = question?.enum_variants?.find((v) => v.id === value || v.id.toString() === valueId);

  return { question, answer };
};

export const tagDescription = (id: string, value: Tags[0], questions?: Tag[]) => {
  const { question, answer } = getData(id, value, questions);
  const namePrefix = question?.name ? `${question.name}: ` : '';
  return `${namePrefix}${answer?.variant_name || value}`;
};

export const tagAnswer = (id: string, value: Tags[0], questions?: Tag[]) => {
  const { answer } = getData(id, value, questions);

  return `${answer?.variant_name || value}`;
};
